import {
  RelayNetworkLayer,
  urlMiddleware,
  // loggerMiddleware,
  errorMiddleware,
  perfMiddleware,
} from 'react-relay-network-modern/es'

export default new RelayNetworkLayer([
  urlMiddleware({
    url:process.env.GRAPHQL_ENDPOINT,
  }),
  perfMiddleware(),
  errorMiddleware(),
])
